<template>
  <section class="views">
    <headers :isBack="false" title="新增學生" v-if="step === 1" />
    <!-- 新增學生表單 -->
    <div class="views_content" v-if="step === 1">
      <div class="views_content_box">
        <ul>
          <!-- 參賽者姓名 -->
          <li>
            <div class="list2">
              <div class="list2_uls">
                <div class="listLeft">參賽者姓名</div>
                <div class="listRight">
                  <input
                    type="text"
                    placeholder="請輸入"
                    v-model.trim="form.studentName"
                    @blur="onBlurInput"
                  />
                </div>
              </div>
            </div>
          </li>

          <!-- 性別 -->
          <li>
            <div class="list">
              <div class="listLeft">性別</div>
              <div class="listRight">
                <div class="listRight_xuan" @click="showSexPicker = true">
                  <span :class="form.gender ? 'placeholderValue' : ''">
                    {{ form.gender || "請選擇" }}
                  </span>
                  <span class="listRight_icon">
                    <van-icon name="arrow-down" size="12" color="#333333" />
                  </span>
                </div>
              </div>
            </div>
          </li>

          <!-- 年級 -->
          <li>
            <div class="list">
              <div class="listLeft">年級</div>
              <div class="listRight">
                <div class="listRight_xuan" @click="showGradePicker = true">
                  <span :class="form.grade ? 'placeholderValue' : ''">
                    {{ form.grade || "請選擇" }}
                  </span>
                  <span class="listRight_icon">
                    <van-icon name="arrow-down" size="12" color="#333333" />
                  </span>
                </div>
              </div>
            </div>
          </li>

          <!-- 非華裔 -->
          <li>
            <div class="list">
              <div class="listLeft">非華裔</div>
              <div class="listRight">
                <div
                  class="listRight_xuan"
                  @click="showNonChinesePicker = true"
                >
                  <span :class="form.nonChinese ? 'placeholderValue' : ''">
                    {{ form.nonChinese || "請選擇" }}
                  </span>
                  <span class="listRight_icon">
                    <van-icon name="arrow-down" size="12" color="#333333" />
                  </span>
                </div>
              </div>
            </div>
          </li>

          <!-- 登入賬號 -->
          <li>
            <div class="list2">
              <div class="list2_uls">
                <div class="listLeft">登入賬號</div>
                <div class="listRight">
                  <input
                    type="text"
                    placeholder="請輸入登入賬號（不可輸入漢字）"
                    v-model.trim="form.studentNo"
                    @input="onLoginAccountInput"
                  />
                </div>
              </div>
            </div>
          </li>

          <!-- 登入密碼 -->
          <li>
            <div class="list2">
              <div class="list2_uls">
                <div class="listLeft">登入密碼</div>
                <div class="listRight">
                  <input
                    type="text"
                    placeholder="請輸入登入密碼（不可輸入漢字）"
                    v-model.trim="form.password"
                    @input="onLoginPasswordInput"
                  />
                </div>
              </div>
            </div>
          </li>

          <!-- 電話號碼 -->
          <li>
            <div class="list2">
              <div class="list2_uls">
                <div class="listLeft">電話號碼</div>
                <div class="listRight">
                  <div class="listRight_sji">
                    <div class="left" @click="pickerPhoneBut">
                      <span>{{ form.prefix }}</span>
                      <span :class="{ '': true, left_formTwo: showPickerTwo }">
                        <van-icon name="arrow-down" size="12" color="#333333" />
                      </span>
                    </div>

                    <div class="right">
                      <input
                        type="number"
                        placeholder="請輸入"
                        v-model.trim="form.phone"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>

          <!-- 電郵 -->
          <li>
            <div class="list2">
              <div class="list2_uls">
                <div class="listLeft">電郵</div>
                <div class="listRight">
                  <input
                    type="email"
                    placeholder="請輸入參賽者電郵"
                    v-model.trim="form.email"
                    @blur="onEmailBlur"
                  />
                </div>
              </div>
            </div>
          </li>

          <!-- 學校名稱（自動填充，不可修改） -->
          <li>
            <div class="list2">
              <div class="list2_uls">
                <div class="listLeft">學校名稱</div>
                <div class="listRight">
                  <input
                    type="text"
                    :value="form.schoolName"
                    disabled
                    style="color:#999;cursor:not-allowed;border:none"
                  />
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>

      <div class="fromButtom">
        <button class="btn btn-cancel" @click="handleCancel">取消</button>
        <button class="btn btn-confirm" @click="handleSubmit">確認新增</button>
      </div>

      <!-- 性別選擇 -->
      <van-popup v-model="showSexPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="sexColumns"
          @confirm="onSexConfirm"
          @cancel="showSexPicker = false"
          confirm-button-text="確認"
        />
      </van-popup>

      <!-- 年級選擇 -->
      <van-popup v-model="showGradePicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="gradeColumns"
          @confirm="onGradeConfirm"
          @cancel="showGradePicker = false"
          confirm-button-text="確認"
        />
      </van-popup>

      <!-- 非華裔選擇 -->
      <van-popup v-model="showNonChinesePicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="nonChineseColumns"
          @confirm="onNonChineseConfirm"
          @cancel="showNonChinesePicker = false"
          confirm-button-text="確認"
        />
      </van-popup>

      <!-- code -->
      <van-popup v-model="showPickerTwo" position="bottom">
        <van-picker
          show-toolbar
          :columns="mobilePhoneColumns"
          @confirm="onPhoneConfirm"
          @cancel="showPickerTwo = false"
          confirm-button-text="確認"
        />
      </van-popup>
    </div>

    <!-- 新增成功頁 -->
    <div class="success_view" v-else>
      <div class="success_header">
        <van-icon name="passed" size="24" color="#ffffff" />
        <span>註冊成功</span>
      </div>

      <div class="success_card">
        <div class="success_title_block">
          <p class="title">APP下載</p>
          <img src="@/assets/image/app_chineserd.png" alt="" />
          <button class="btn btn-download" @click="handleDownloadApp">
            點擊下載
          </button>
        </div>

        <div class="info_box">
          <div class="info_item">請下載APP進行登入，你的登入信息如下</div>
          <div class="info_item">學校編號：{{ schoolCode }}</div>
          <div class="info_item">登入賬號為：{{ studentNo }}</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import headers from "@/components/header/custom2.vue";
import publics from "@/mixin/public_mixin";

export default {
  name: "addStudentH5",
  components: {
    headers,
  },
  mixins: [publics],
  data() {
    return {
      step: 1, // 1 表單，2 成功
      form: {
        studentName: "",
        gender: "",
        grade: "",
        nonChinese: "",
        studentNo: "",
        password: "",
        prefix: "+852",
        phone: "",
        email: "",
        schoolName: "",
        schoolNo: "",
      },
      sexColumns: ["男", "女"],
      gradeColumns: [
        "K1",
        "K2",
        "K3",
        "P1",
        "P2",
        "P3",
        "P4",
        "P5",
        "P6",
        "S1",
        "S2",
        "S3",
        "S4",
        "S5",
        "S6",
      ],
      nonChineseColumns: ["是", "否"],
      mobilePhoneColumns: ["+852", "+86"],
      showSexPicker: false,
      showGradePicker: false,
      showNonChinesePicker: false,
      showPickerTwo: false,
      schoolId: "",
      schoolCode: "",
      studentNo: "",
    };
  },
  mounted() {
    this.initSchoolInfo();
  },
  methods: {
    // 初始化學校信息：從 URL 中讀取 schoolCode 並請求接口
    initSchoolInfo() {
      const urlParams = new URLSearchParams(window.location.search);
      const schoolId = urlParams.get("id");
      const schoolCode = urlParams.get("schoolCode");
      const schoolName = urlParams.get("schoolName");
      if (!schoolId) {
        this.$toast && this.$toast.fail("缺少學校編號參數");
        return;
      }
      this.form.schoolName = schoolName || "";
      this.schoolId = schoolId || "";
      this.schoolCode = schoolCode || "";
    },
    // 處理 iOS 軟鍵盤頂起
    onBlurInput() {
      window.scroll(0, 0);
    },
    // 取消
    handleCancel() {
      // 转到首页
      this.$router.push({ path: "/" });
    },
    // 電話號碼校驗
    validator_phone(val) {
      const phone = (val || "").trim();
      return /^[0-9]*$/.test(phone);
    },
    // 電郵校驗（沿用原頁邏輯）
    validator_email(val) {
      const email = (val || "").trim();
      return /^[A-Za-z0-9]+([_\-.][A-Za-z0-9]+)*@([A-Za-z0-9\-_]+\.)+[A-Za-z]{2,6}$/.test(
        email
      );
    },
    // 電話輸入過濾，只保留數字
    onPhoneInput(e) {
      const raw = e.target.value || "";
      const filtered = raw.replace(/[^0-9]/g, "");
      this.form.phone = filtered;
      if (filtered !== raw) {
        e.target.value = filtered;
      }
    },
    // 電郵輸入失焦即時校驗
    onEmailBlur() {
      if (!this.form.email) return;
      if (!this.validator_email(this.form.email)) {
        this.$toast && this.$toast.fail("電郵格式有誤，請重新輸入");
      }
    },
    // 表單校驗
    validateForm() {
      const f = this.form;

      if (!f.studentName) {
        this.$toast.fail("請輸入參賽者姓名");
        return false;
      }
      if (!f.gender) {
        this.$toast.fail("請選擇性別");
        return false;
      }
      if (!f.grade) {
        this.$toast.fail("請選擇年級");
        return false;
      }
      if (!f.nonChinese) {
        this.$toast.fail("請選擇是否非華裔");
        return false;
      }
      if (!f.studentNo) {
        this.$toast.fail("請輸入登入賬號");
        return false;
      }
      // if (!/^[A-Za-z0-9_]+$/.test(f.studentNo)) {
      //   this.$toast.fail("登入賬號僅支持字母、數字和下劃線");
      //   return false;
      // }
      if (!f.password) {
        this.$toast.fail("請輸入登入密碼");
        return false;
      }
      if (!f.phone) {
        this.$toast.fail("請輸入電話號碼");
        return false;
      }
      if (!this.validator_phone(f.phone)) {
        this.$toast.fail("電話號碼格式有誤");
        return false;
      }
      if (!f.email) {
        this.$toast.fail("請輸入電郵");
        return false;
      }
      if (!this.validator_email(f.email)) {
        this.$toast.fail("電郵格式有誤");
        return false;
      }
      if (!f.schoolName) {
        this.$toast.fail("學校名稱獲取失敗");
        return false;
      }
      return true;
    },
    // 提交
    handleSubmit() {
      if (!this.validateForm()) return;
      const {
        prefix,
        phone,
        studentName,
        email,
        grade,
        gender,
        nonChinese,
        password,
        studentNo,
      } = this.form;
      const params = {
        prefix,
        phone,
        studentName,
        email,
        grade,
        gender,
        nonChinese,
        password,
        studentNo,
        schoolId: this.schoolId,
        platform: !localStorage.getItem("c") ? "H5" : localStorage.getItem("c"),
      };
      this.$toast.loading({
        message: "正在提交中...",
        forbidClick: true,
        duration: 0,
      });

       this.$axios
        .post(this.$api.addStudent, params)
        .then((res) => {
          this.$toast.clear();
          const { code, msg } = res.data;
          if (code === 0) {
            this.studentNo = studentNo;
            this.$toast.success("新增成功");
            this.step = 2;
          } else {
            this.$toast.fail(msg || "新增失敗");
          }
        })
        .catch(() => {
          this.$toast.clear();
          this.$toast.fail("網絡錯誤，請稍後重試");
        });
    },
    // 選擇器回調
    onSexConfirm(val) {
      this.form.gender = val;
      this.showSexPicker = false;
    },
    onGradeConfirm(val) {
      this.form.grade = val;
      this.showGradePicker = false;
    },
    onNonChineseConfirm(val) {
      this.form.nonChinese = val;
      this.showNonChinesePicker = false;
    },
    // APP 下載
    handleDownloadApp() {
      const url = "https://app.chineserd.com/";
      window.location.href = url;
    },
    pickerPhoneBut() {
      this.showPickerTwo = true;
    },
    onPhoneConfirm(e) {
      console.log(e);
      this.form.prefix = e;
      this.showPickerTwo = false;
    },
    // 登入賬號/密碼：禁止輸入漢字，允許大小寫字母、符號、數字
    onLoginAccountInput(e) {
      const val = String(e.target.value);
      // 去除所有 CJK（中文）字符
        const sanitized = val.replace(/[\p{Script=Han}\s]/gu, "");
      this.from.studentNo = sanitized;
    },
    onLoginPasswordInput(e) {
      const val = String(e.target.value);
        const sanitized = val.replace(/[\p{Script=Han}\s]/gu, "");
      this.from.password = sanitized;
    },
  },
};
</script>

<style lang="scss" scoped>
.views {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  .views_content {
    width: 100%;
    height: calc(100vh - 1rem);
    padding-bottom: 2rem;
    box-sizing: border-box;
    overflow-x: hidden;
    background: #fafafa;
    position: relative;

    .views_content_box {
      padding: 0.32rem;
      box-sizing: border-box;

      ul {
        width: 100%;
        padding: 0 0.32rem;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 0.16rem;

        li:last-child {
          border-bottom: none !important;
        }

        li {
          width: 100%;
          border-bottom: 0.02rem solid #f2f2f2;
          display: flex;

          .list {
            width: 100%;
            height: 1.04rem;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .listLeft {
              font-size: 0.28rem;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
            }

            .listRight {
              width: 70%;
              height: 100%;
              display: flex;

              input {
                width: 100%;
                height: 100%;
                font-size: 0.28rem;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #000000;
                border: none;
                text-align: right;
                background: none;
                padding: 0;
                box-sizing: border-box;
              }

              input::-webkit-input-placeholder {
                color: #cccccc;
              }
              input:-moz-placeholder {
                color: #cccccc;
              }
              input::-moz-placeholder {
                color: #cccccc;
              }
              input:-ms-input-placeholder {
                color: #cccccc;
              }

              .listRight_xuan {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                text-align: right;
                justify-content: flex-end;
                color: #cccccc;
                font-size: 0.28rem;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;

                .placeholderValue {
                  color: #000000 !important;
                }

                .listRight_icon {
                  margin-left: 0.1rem;
                }
              }
            }
          }

          .list2 {
            width: 100%;

            .list2_uls {
              width: 100%;
              height: 1.04rem;
              display: flex;
              align-items: center;
              justify-content: space-between;

              .listLeft {
                font-size: 0.28rem;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #333333;
              }

              .listRight {
                width: 70%;
                height: 100%;
                display: flex;

                input {
                  width: 100%;
                  height: 100%;
                  font-size: 0.28rem;
                  font-family: PingFang SC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #000000;
                  border: none;
                  text-align: right;
                  background: none;
                  padding: 0;
                  box-sizing: border-box;
                }

                input::-webkit-input-placeholder {
                  color: #cccccc;
                }
                input:-moz-placeholder {
                  color: #cccccc;
                }
                input::-moz-placeholder {
                  color: #cccccc;
                }
                input:-ms-input-placeholder {
                  color: #cccccc;
                }

                .listRight_xuan {
                  width: 100%;
                  height: 100%;
                  display: flex;
                  align-items: center;
                  text-align: right;
                  justify-content: flex-end;
                  color: #cccccc;
                  font-size: 0.28rem;
                  font-family: PingFang SC-Regular, PingFang SC;
                  font-weight: 400;

                  .placeholderValue {
                    color: #000000 !important;
                  }

                  .listRight_icon {
                    margin-left: 0.1rem;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .listRight_sji {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    text-align: right;
    justify-content: flex-end;
    color: #cccccc;
    font-size: 0.28rem;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;

    .left {
      font-size: 0.28rem;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      height: 100%;
      display: flex;
      align-items: center;
      position: relative;
      padding-right: 0.32rem;
      box-sizing: border-box;

      span:nth-child(1) {
        font-size: 0.28rem;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        margin-right: 0.08rem;
      }

      .left_formTwo {
        transform: rotate(180deg);
      }
    }

    .left:after {
      content: " ";
      width: 0.01rem;
      height: 50%;
      background: #cccccc;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      margin: auto;
    }

    .right {
      padding-left: 0.32rem;
      box-sizing: border-box;
      width: 2.5rem;
      height: 100%;
    }
  }
  .fromButtom {
    position: fixed;
    bottom: 2%;
    left: 0;
    right: 0;
    padding: 0 0.32rem;
    box-sizing: border-box;
    width: 100%;
    display: flex;
    justify-content: center;

    .btn {
      flex: 1;
      height: 0.96rem;
      border-radius: 0.48rem;
      font-size: 0.32rem;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      border: none;
      outline: none;
    }

    .btn-cancel {
      margin-right: 0.24rem;
      background: #ffffff;
      color: #ff6b00;
      border: 0.02rem solid #ff6b00;
    }

    .btn-confirm {
      margin-left: 0.24rem;
      background: #ff6b00;
      color: #ffffff;
      box-shadow: 0px 4px 9px 0px rgba(255, 107, 0, 0.4);
    }
  }
}

.success_view {
  flex: 1;
  width: 100%;
  height: calc(100vh - 0.8rem);
  background: #ff6b00;
  padding: 0.8rem 0.32rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;

  .success_header {
    display: flex;
    align-items: center;
    color: #ffffff;
    font-size: 0.36rem;
    margin-bottom: 0.48rem;

    span {
      margin-left: 0.16rem;
    }
  }

  .success_card {
    width: 100%;
    background: #ffffff;
    border-radius: 0.32rem;
    padding: 0.48rem 0.32rem 0.64rem;
    box-sizing: border-box;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
    overflow: hidden;

    .success_title_block {
      text-align: center;
      margin-bottom: 0.4rem;

      .title {
        font-size: 0.34rem;
        font-weight: 600;
        color: #333333;
        margin-bottom: 0.12rem;
      }

      img {
        width: 100%;
        max-width: 4rem;
        height: auto;
        border-radius: 0.16rem;
        box-shadow: 0 0.12rem 0.24rem rgba(0, 0, 0, 0.08);
        margin: 0.24rem auto 0.32rem;
        display: block;
      }

      .btn-download {
        width: 100%;
        height: 0.88rem;
        border-radius: 0.44rem;
        border: none;
        background: linear-gradient(90deg, #ff9a2b 0%, #ff6b00 100%);
        color: #ffffff;
        font-size: 0.32rem;
        font-weight: 600;
        box-shadow: 0px 0.12rem 0.24rem 0px rgba(255, 107, 0, 0.45);
      }
    }

    .info_box {
      width: 100%;
      background: #fff7ec;
      border-radius: 0.24rem;
      padding: 0.4rem 0.28rem;
      box-sizing: border-box;
      border: 1px solid #ffd9b3; /* 边框保留 px 精度 */

      .info_item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 0.28rem;
        color: #333333;
        line-height: 0.44rem;

        & + .info_item {
          margin-top: 0.32rem;
        }
      }
    }

    /* 小屏适配：限制卡片最大宽度并居中 */
    @media (min-width: 768px) {
      max-width: 8rem;
      margin: 0 auto;
    }
  }
}
</style>
